import InsightsPage from "./insights-page" ;

export default InsightsPage 